import { Fragment } from "react";
import images from "../../../utilities/images/images";
import "./ContactUsNavbar.scss";

const ContactUsNavbar = () => {
  return (
    <Fragment>
      <navbar>
        <div className="navbar-container-contactus">
          <div className="motion-logo">
            <img
              src={images.landingPageLogo}
              alt="motion-logo"
              onClick={() => (window.location.href = "/")} // Navigate to home
            />
          </div>
        </div>
      </navbar>
      <navbar>
        <div className="mobile-navbar-container">
          <div className="mobile-nav-contactus">
            <div className="mobile-nav-row">
              <div className="motion-logo">
                <img
                  src={images.landingPageLogo}
                  alt="motion-logo"
                  onClick={() => window.open("https://motion.ac.in/", "_blank")}
                />
              </div>
            </div>
          </div>
        </div>
      </navbar>
    </Fragment>
  );
};

export default ContactUsNavbar;
